import { motion, useReducedMotion } from "framer-motion";
import { Logo } from "@/components/Logo";

export function SplashScreen() {
  const prefersReducedMotion = useReducedMotion();
  
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background backdrop-blur-sm pointer-events-none">
      <div className="relative w-48 h-48 flex items-center justify-center">
        <div
          aria-hidden
          className="absolute inset-0 rounded-2xl border-4 border-border/50 animate-spin transform-gpu"
          style={{ 
            animationDuration: '3s', 
            animationTimingFunction: 'linear', 
            willChange: 'transform, opacity', 
            opacity: prefersReducedMotion ? 0.4 : 1 
          }}
        />
        <div
          aria-hidden
          className="absolute inset-0 rounded-2xl border-2 border-primary/30 animate-spin transform-gpu"
          style={{ 
            animationDuration: '3s', 
            animationTimingFunction: 'linear', 
            animationDirection: 'reverse', 
            willChange: 'transform, opacity', 
            opacity: prefersReducedMotion ? 0.5 : 1 
          }}
        />
        <div
          aria-hidden
          className="absolute inset-0 rounded-2xl border border-border animate-spin transform-gpu"
          style={{ 
            animationDuration: '2s', 
            animationTimingFunction: 'linear', 
            willChange: 'transform, opacity', 
            opacity: prefersReducedMotion ? 0.6 : 1 
          }}
        />

        <div className="absolute -inset-4 rounded-full blur-xl bg-foreground/6" />
        <div className="absolute -inset-8 rounded-full blur-3xl bg-foreground/3" />

        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={prefersReducedMotion ? { opacity: 1 } : { opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease: "easeOut", delay: 0.2 }}
          className="relative z-10"
          style={{ willChange: 'transform, opacity' }}
        >
          <Logo width={40} height={40} />
        </motion.div>
      </div>

      <div className="absolute bottom-16 text-sm font-medium text-muted-foreground">
        <div 
          className={prefersReducedMotion ? '' : 'animate-pulse'} 
          style={{ willChange: 'opacity' }}
        >
          Loading...
        </div>
      </div>
    </div>
  );
}

export default SplashScreen;

